import React, { useEffect, useState } from 'react';

const PendingVendors = () => {
  const [pending, setPending] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const token = localStorage.getItem('partner_token');
    fetch('https://abomed-backend-nodejs.vercel.app/partner/pending-vendors', {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
      .then(res => res.json())
      .then(data => {
        setPending(data.data || []);
        setLoading(false);
      })
      .catch(() => {
        setError('Failed to fetch pending vendors');
        setLoading(false);
      });
  }, []);

  if (loading) return <div>Loading pending vendors...</div>;
  if (error) return <div>{error}</div>;

  return (
    <div>
      <h3>Pending Vendors</h3>
      {pending.length === 0 ? (
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: 220,
          margin: '32px 0',
        }}>
          <div style={{
            background: '#fff',
            borderRadius: 12,
            padding: '36px 2px',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            maxWidth: 340,
            width: '100%'
          }}>
            <div style={{ fontSize: 48, color: '#bdbdbd', marginBottom: 12 }}>
              <svg width="48" height="48" fill="none" viewBox="0 0 24 24"><path fill="#bdbdbd" d="M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20Zm0 18a8 8 0 1 1 0-16 8 8 0 0 1 0 16Zm-1-7V8a1 1 0 1 1 2 0v5a1 1 0 0 1-2 0Zm1 4a1.25 1.25 0 1 1 0-2.5 1.25 1.25 0 0 1 0 2.5Z"/></svg>
            </div>
            <div style={{ fontWeight: 600, color: '#b71c1c', fontSize: 18, marginBottom: 6 }}>
              No Partners Found
            </div>
            <div style={{ color: '#757575', fontSize: 15, textAlign: 'center' }}>
              There are currently no pending partners to display.
            </div>
          </div>
        </div>
      ) : (
        <div style={{ width: '100%', overflowX: 'auto' }}>
          <table style={{ minWidth: 700, width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr>
                <th style={{ padding: 8, border: '1px solid #ddd', background: '#f5f5f5' }}>ID</th>
                <th style={{ padding: 8, border: '1px solid #ddd', background: '#f5f5f5' }}>Type</th>
                <th style={{ padding: 8, border: '1px solid #ddd', background: '#f5f5f5' }}>Contact Person</th>
                <th style={{ padding: 8, border: '1px solid #ddd', background: '#f5f5f5' }}>Pincode</th>
                <th style={{ padding: 8, border: '1px solid #ddd', background: '#f5f5f5' }}>State</th>
                <th style={{ padding: 8, border: '1px solid #ddd', background: '#f5f5f5' }}>City</th>
                <th style={{ padding: 8, border: '1px solid #ddd', background: '#f5f5f5' }}>Step</th>
                <th style={{ padding: 8, border: '1px solid #ddd', background: '#f5f5f5' }}>Created At</th>
              </tr>
            </thead>
            <tbody>
              {pending.map(vendor => (
                <tr key={vendor.id}>
                  <td style={{ padding: 8, border: '1px solid #ddd' }}>{vendor.id}</td>
                  <td style={{ padding: 8, border: '1px solid #ddd' }}>{vendor.vendor_type}</td>
                  <td style={{ padding: 8, border: '1px solid #ddd' }}>{vendor.contact_person_name}</td>
                  <td style={{ padding: 8, border: '1px solid #ddd' }}>{vendor.pincode}</td>
                  <td style={{ padding: 8, border: '1px solid #ddd' }}>{vendor.state}</td>
                  <td style={{ padding: 8, border: '1px solid #ddd' }}>{vendor.city}</td>
                  <td style={{ padding: 8, border: '1px solid #ddd' }}>{vendor.step}</td>
                  <td style={{ padding: 8, border: '1px solid #ddd' }}>{new Date(vendor.created_at).toLocaleString()}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default PendingVendors;
